// DetailSection/DetailSection.tsx
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import React, { memo, type ReactNode } from 'react';

import styles from './styles.module.css';

export interface DetailSectionProps {
  title: string;
  toolbar?: ReactNode;
  children: ReactNode;
  'data-testid'?: string;
}

function DetailSectionComponent({ title, toolbar, children, 'data-testid': testId }: DetailSectionProps) {
  return (
    <Stack className={styles.section} data-testid={testId} gap={3} orientation="vertical">
      <Stack alignItems="center" className={styles.header} justifyContent="space-between" orientation="horizontal">
        <Text as="h2" size="lg">
          {title}
        </Text>
        {toolbar}
      </Stack>
      {children}
    </Stack>
  );
}

export const DetailSection = memo(DetailSectionComponent);
